import * as angular from 'angular';

import { ComponentDefinition } from '../../models';

class MoreController implements angular.IComponentController {
    hasMore: boolean;
    isLoading: boolean;
    loadingMessage: string;
    more: () => any;
    text: string;

    static $inject = [];

}

export const wtMore: ComponentDefinition = {
    componentId: 'wtMore',
    controller: MoreController,
    template: require('./more.component.html'),
    controllerAs: 'vm',
    bindings: {
        hasMore: '<?',
        icon: '<?',
        more: '&',
        text: '@?'
    }
};
